import type { KitGroup, WizardLine } from '../types/wizard';

export type KitBomItem = Record<string, unknown> & {
  Material?: string;
  to_CItems?: { CItem?: unknown };
};

function normMaterial(code: string): string {
  return code.trim().toUpperCase();
}

export function bomComponentQty(
  bom: KitBomItem[] | null,
  kitMaterial: string,
  materialCode: string
): number | null {
  if (!bom?.length) return null;
  const kit = bom.find((k) => String(k.Material ?? '') === kitMaterial);
  const cItems = kit?.to_CItems?.CItem;
  const list = cItems
    ? Array.isArray(cItems)
      ? (cItems as Record<string, unknown>[])
      : [cItems as Record<string, unknown>]
    : [];
  const comp = list.find(
    (c) =>
      normMaterial(String(c.Material ?? c.Component ?? '')) === normMaterial(materialCode)
  );
  if (!comp) return null;
  return parseInt(String(comp.Quantity ?? '0'), 10) || 0;
}

export function effectiveWhQty(
  line: WizardLine,
  kitGroups: KitGroup[],
  kitIndex: number,
  bom: KitBomItem[] | null
): number {
  if (line.isKitHeader) return line.quantity;
  const kit = kitGroups[kitIndex];
  if (!kit) return line.quantity;
  const bomQty = bomComponentQty(bom, kit.kitMaterial, line.materialCode);
  if (bomQty != null) {
    return kit.kitQty * bomQty;
  }
  return line.quantity;
}
